import { Helmet } from "react-helmet-async";

import BuilderSectionLazy from "../../modules/builder/BuilderSectionLazy";

import useTranslatePath from "../../hooks/useTranslatePath";

import { t } from "../../lib/translations";

const NewsletterSubscribed = () => {
    const { getPath } = useTranslatePath();

    return (
        <>
            <Helmet>
                <title>{ t('newsletter.subscribed') }</title>
                <meta name="description" content={''} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <BuilderSectionLazy model="newsletter-subscribed" url={getPath('/newsletter-subscribed')} />
        </>
    )
}

export default NewsletterSubscribed;